import { navigateToOrderDetail } from '@/features/orders/thunks/navigateToOrderDetail'
import { useAppDispatch } from '@/hooks/redux'
import { UnknownInputParams } from 'expo-router'
import { useCallback } from 'react'

export const useOrderDetailNavigation = () => {
    const dispatch = useAppDispatch()

    return useCallback(
        (id: string, params?: UnknownInputParams) => {
            dispatch(navigateToOrderDetail({ id, params }))
        },
        [dispatch]
    )
}
